import { useSelector } from "react-redux";

import { EntityTypesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

import { getEmailDraftsByEntityType } from "@app/store/email";

const useEntityTypeEmailTemplates = (entityType: EntityTypesSupportedByEmailFeature) => {
  return useSelector((state) => getEmailDraftsByEntityType(state, entityType));
};

export default useEntityTypeEmailTemplates;
